import React, { FC } from 'react';
import { Shop, FilterState, FilterOption } from '../../types';
import ShopCard from '../ShopCard/ShopCard.index';
import FilterPanel from '../FilterPanel/FilterPanel.index';

export interface ShopListViewProps {
  shops: Shop[];
  searchCondition: string;
  totalCount: number;
  facilityOptions: FilterOption[];
  serviceOptions: FilterOption[];
  filters: FilterState;
  onFilterChange: (filters: FilterState) => void;
  onApplyFilter: () => void;
  onClearFilter: () => void;
  onBookmark: (shopId: string) => void;
  onReserve: (shopId: string, shopName: string, preOpenDay: string) => void;
}

const ShopListView: FC<ShopListViewProps> = ({
  shops,
  searchCondition = '',
  totalCount,
  facilityOptions,
  serviceOptions,
  filters,
  onFilterChange,
  onApplyFilter,
  onClearFilter,
  onBookmark,
  onReserve,
}) => {
  return (
    <div className="p-shop-list">
      <div className="p-black-box">
        {searchCondition ? `"${searchCondition}"で検索` : '検索結果'}
        <span>({totalCount}店舗)</span>
      </div>

      <div className="p-shop-list__inner">
        <div className="p-shop-list__main">
          {shops.map((shop) => (
            <ShopCard key={shop.id} shop={shop} onBookmark={onBookmark} onReserve={onReserve} isMapVersion={false} />
          ))}
        </div>

        <div className="p-shop-list__side-menu">
          <FilterPanel
            isMobile={false}
            facilityOptions={facilityOptions}
            serviceOptions={serviceOptions}
            filters={filters}
            onFilterChange={onFilterChange}
            onApply={onApplyFilter}
            onClear={onClearFilter}
          />
        </div>
      </div>
    </div>
  );
};

export default ShopListView;
